// kvd
import * as Rx from 'rxjs';
import * as _ from "lodash"
import * as PAdbSchemaRows from './PAdbSchemaRows';
import {IIdentityProvider, IDateRange} from "./PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs";
import {IPolicyCollection} from "./PA.Core.IF.Policy";
import {ESRecord} from "./lib/ESRecord";
import {
    WB_CircularConfigRow,
    WB_CircularRow,
    WB_EventCircularRow, WB_EventProductGroupRow,
    WB_EventRow,
    WB_FinishedProductRow
} from "./PAdbSchemaRows";


interface IHaveTags {
    // Loading
    readonly bIHaveTagsLoaded: boolean;
    readonly OnIHaveTagsLoaded: Promise<IHaveTags>; // triggers the load process...if needed.


    // API
    readonly TagsReadOnly: boolean;

    addTag(TagId: number): Promise<void>;

    removeTag(TagId: number): void;

    hasTag(TagId: number): boolean;

    readonly Tags: PAdbSchemaRows.WB_TagRow[];

    // Allow for Dates on
    readonly bTagHasDateRange?: boolean

    setDateRange?(TagId: number, dRange: IDateRange): void;

    getDateRange?(TagId: number): IDateRange


    // Fire when the above changes
    readonly TagsChanged: Rx.BehaviorSubject<IHaveTags>;
    readonly AllTags: PAdbSchemaRows.WB_TagRow[];
    readonly UsageId: string // Top Tag Id
}

function instanceOfIHaveTags(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveTagsLoaded', 'OnIHaveTagsLoaded', 'TagsReadOnly',
        'addTag', 'removeTag', 'hasTag',
        'Tags', 'TagsChanged', 'AllTags']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}

interface IHaveSourceCustomers {
    // Loading
    readonly bIHaveSourceCustomersLoaded: boolean;
    readonly OnIHaveSourceCustomersLoaded: Promise<IHaveSourceCustomers>; // triggers the load process...

    // API
    readonly SourceCustomersReadOnly: boolean;

    addSourceCustomer(SourceCustomerId: number): Promise<void>;

    removeSourceCustomer(SourceCustomerId: number): Promise<void>;

    hasSourceCustomer(SourceCustomerId: number): boolean;

    isSourceCustomerEditable(SourceCustomerId: number): boolean;

    readonly SourceCustomers: PAdbSchemaRows.WB_CustomerRow[];

    // Fire when the above changes
    readonly SourceCustomersChanged: Rx.BehaviorSubject<IHaveSourceCustomers>;

    readonly AllSourceCustomers: PAdbSchemaRows.WB_CustomerRow[];  // possible selections

}

function instanceOfIHaveSourceCustomers(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveSourceCustomersLoaded', 'OnIHaveSourceCustomersLoaded', 'SourceCustomersReadOnly',
        'addSourceCustomer', 'removeSourceCustomer', 'hasSourceCustomer',
        'SourceCustomers', 'SourceCustomersChanged', 'AllSourceCustomers']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


interface IHaveProductGroups {
    // Loading
    readonly bIHaveProductGroupsLoaded: boolean;
    readonly OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>; // triggers the load process...

    // API
    readonly ProductGroupsReadOnly: boolean;

    addProductGroup(ProductGroupId: number): Promise<void>;

    removeProductGroup(ProductGroupId: number): Promise<void>;

    hasProductGroup(ProductGroupId: number): boolean;

    isProductGroupEditable(ProductGroupId: number): boolean;

    readonly ProductGroups: PAdbSchemaRows.WB_ProductGroupRow[];

    addProductGroups?(arrProductGroupId: number[]): Promise<void>;

    removeProductGroups?(arrProductGroupId: number[]): Promise<void>;

    // Fire when the above changes
    readonly ProductGroupsChanged: Rx.BehaviorSubject<IHaveProductGroups>;

    readonly AllProductGroups: PAdbSchemaRows.WB_ProductGroupRow[];
}

function instanceOfIHaveProductGroups(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveProductGroupsLoaded', 'OnIHaveProductGroupsLoaded', 'ProductGroupsReadOnly',
        'addProductGroup', 'removeProductGroup', 'hasProductGroup',
        'ProductGroups', 'ProductGroupsChanged', 'AllProductGroups']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


interface IHaveFinishedProducts {
    // Loading
    readonly bIHaveFinishedProductsLoaded: boolean;
    readonly OnIHaveFinishedProductsLoaded: Promise<IHaveFinishedProducts>; // triggers the load process...

    // API
    readonly FinishedProductsReadOnly: boolean;

    addFinishedProduct(WB_Prod_Id: number): Promise<void>;

    removeFinishedProduct(WB_Prod_Id: number): void;

    hasFinishedProduct(WB_Prod_Id: number): boolean;

    readonly FinishedProducts: PAdbSchemaRows.WB_FinishedProductRow[];

    // Fire when the above changes
    readonly FinishedProductsChanged: Rx.BehaviorSubject<IHaveFinishedProducts>;
}

function instanceOfIHaveFinishedProducts(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveFinishedProductsLoaded', 'OnIHaveFinishedProductsLoaded', 'FinishedProductsReadOnly',
        'addFinishedProduct', 'removeFinishedProduct', 'hasFinishedProduct',
        'FinishedProducts', 'FinishedProductsChanged']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


interface IHaveExecutionDates {
    // Loading
    readonly bIHaveExecutionDatesLoaded: boolean;
    readonly OnIHaveExecutionDatesLoaded: Promise<IHaveExecutionDates>; // triggers the load process...

    // Retailer Execution
    InStore: IDateRange
    readonly InStoreSource: IDateRange
    readonly InStoreBounds: IDateRange
    readonly bInStoreDatesExist: boolean
    readonly bInStoreDatesReadOnly: boolean
    readonly bInStoreDatesValid: boolean

    // Manufacturer Shipment/ Order Execution
    // Shipment
    Shipment: IDateRange
    readonly ShipmentSource: IDateRange
    readonly ShipmentBounds: IDateRange
    readonly bShipmentDatesExist: boolean
    readonly bShipmentDatesReadOnly: boolean
    readonly bShipmentDatesValid: boolean

    // Order
    Order: IDateRange
    readonly OrderSource: IDateRange
    readonly OrderBounds: IDateRange
    readonly bOrderDatesExist: boolean
    readonly bOrderDatesReadOnly: boolean
    readonly bOrderDatesValid: boolean

    // Fire when the above changes
    readonly DatesChanged: Rx.BehaviorSubject<IHaveExecutionDates>;

}


function instanceOfIHaveExecutionDates(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveExecutionDatesLoaded', 'OnIHaveExecutionDatesLoaded',
        'InStore', 'Shipment', 'Order',
        'InStoreBounds', 'ShipmentBounds', 'OrderBounds', 'DatesChanged']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


interface IHaveExecutionBounds {
    // Loading
    readonly bIHaveExecutionBoundsLoaded: boolean;
    readonly OnIHaveExecutionBoundsLoaded: Promise<IHaveExecutionBounds>; // starts the load process...

    // API
    readonly Execution_Bounds_Identity: IIdentityProvider
    readonly Execution_InStore: IDateRange;
    readonly Execution_InStore_Aligned: IDateRange;
    readonly Execution_Shipment: IDateRange;
    readonly Execution_Shipment_Aligned: IDateRange;
    readonly Execution_PlanningCustomers: PAdbSchemaRows.WB_CustomerRow[];
    readonly Execution_SourceCustomers: PAdbSchemaRows.WB_CustomerRow[];
    readonly Execution_ProductGroups: PAdbSchemaRows.WB_ProductGroupRow[];
    readonly Execution_FinishedProducts: PAdbSchemaRows.WB_FinishedProductRow[];

    getProductsByProductGroup?(wbPGId: number): WB_FinishedProductRow[];

    // Fire when the above changes
    readonly ExecutionBoundsChanged: Rx.BehaviorSubject<IHaveExecutionBounds>;
}

function instanceOfIHaveExecutionBounds(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['bIHaveExecutionBoundsLoaded', 'OnIHaveExecutionBoundsLoaded', 'Execution_Bounds_Identity',
        'Execution_InStore', 'Execution_Shipment', 'Execution_PlanningCustomers', 'Execution_SourceCustomers',
        'Execution_ProductGroups', 'Execution_FinishedProducts', 'ExecutionBoundsChanged']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}


interface IHaveSecurity {
    readonly bIHaveSecurityLoaded: boolean;
    readonly OnIHaveSecurityLoaded: Promise<IHaveSecurity>; // starts the load process...
    readonly PolicyCollection: IPolicyCollection
}

function instanceOfIHaveSecurity(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }
    var checkFields = ['PolicyCollection', 'bIHaveSecurityLoaded', 'OnIHaveSecurityLoaded']
    var returnValue = true
    _.forEach(checkFields, (fieldName: string) => {
        if (!(fieldName in obj)) {
            returnValue = false
            return false
        }
    })
    return returnValue
}

interface IReference {
    readonly count: number,

    incr(): void,

    decr(): void,

    OnUnreferenced(aFunction: () => void, thisContext?: any): void
}

interface IHaveReferences {
    Reference: IReference
}

export interface ICircularRow {
    Mapped: boolean;
    WB_Event_Circular_ID: number;
    WB_Circular_ID: number;
    Date_From: number;
    Date_To: number;
    circularRow: WB_CircularRow
}

export interface IHaveCircular {
    Circulars: ICircularRow[]
    readonly  CircularConfig: WB_CircularConfigRow
    readonly OnIHaveCircularLoaded: Promise<void>

    addEventCircular(wbCircularId: number): Promise<WB_EventCircularRow>

    removeEventCircular(wbEventCircularId: number): void

    readonly bCircularLoaded: boolean
}

export interface IEDLCLinkedRow {
    Granted: boolean,
    WB_EVTFR_ID:number,
    EventRow: WB_EventRow,
    Products: string,
    ProductDescription: string,
    Discount: number,
    IncrUnits: number,
    IncrProfit: number,
    ConsumptionLift:number,
    SalesLift:number,
    INSTORE_START_DT:string,
    INSTORE_END_DT:string
}


function instanceOfIHaveReferences(obj: any): boolean {
    if ((_.isEmpty(obj)) || (!_.isObject(obj))) {
        return false
    }

    return 'Reference' in obj
}


export interface IHaveLanguageTextChangeEvent {
    LanguageText: IHaveLanguageText,
    LanguageTextRow: ILanguageTextRow,
    FieldName: string
}

export interface IHaveLanguageText {

    readonly bIsLoaded: boolean
    readonly OnLoadComplete: Promise<IHaveLanguageText>
    readonly Id: string
    readonly Name: string
    readonly bHasText: boolean
    readonly bHasShortText: boolean
    readonly bHasAbbreviation: boolean
    readonly bHasTooltip: boolean

    readonly Languages: string[]
    readonly LanguageTextRows: ILanguageTextRow[]

    getTextRow(languageCd: string): ILanguageTextRow

    readonly TextChanged: BehaviorSubject<IHaveLanguageTextChangeEvent>
}

export interface ILanguageTextRow {
    readonly Parent: IHaveLanguageText,
    readonly LanguageCode: string,
    readonly Row: ESRecord,

    Text: string,
    ShortText: string,
    Abbreviation: string,
    Tooltip: string
}


interface IHaveSalesAreas {
    // Loading
    readonly bIHaveSalesAreaLoaded: boolean;
    readonly OnIHaveSalesAreasLoaded: Promise<IHaveSalesAreas>; // triggers the load process...

    // API
    readonly SalesAreasReadOnly: boolean;

    addSalesArea(SalesAreaId: number): Promise<void>;
    removeSalesArea(SalesAreaId: number): Promise<void>;
    hasSalesArea(SalesAreaId: number): boolean;
    isSalesAreaEditable(SalesAreaId: number): boolean;
    readonly SalesAreas: PAdbSchemaRows.WB_SalesAreaRow[];
    addSalesAreas?(arrSalesAreaId: number[]): Promise<void>;
    removeSalesAreas?(arrSalesAreaId: number[]): Promise<void>;

    // Fire when the above changes
    readonly SalesAreasChanged: Rx.BehaviorSubject<IHaveSalesAreas>;
    readonly AllSalesAreas: PAdbSchemaRows.WB_SalesAreaRow[];
}


export {
    IHaveTags, instanceOfIHaveTags,
    IHaveSourceCustomers, instanceOfIHaveSourceCustomers,
    IHaveProductGroups, instanceOfIHaveProductGroups,
    IHaveFinishedProducts, instanceOfIHaveFinishedProducts,
    IHaveExecutionBounds, instanceOfIHaveExecutionBounds,
    IHaveExecutionDates, instanceOfIHaveExecutionDates,
    IHaveSecurity, instanceOfIHaveSecurity,
    IReference, IHaveReferences, instanceOfIHaveReferences,
    IHaveSalesAreas
}
